// extracted by mini-css-extract-plugin
module.exports =  {"counter":"_2787e5dfdf--counter--yl3su"};